import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import openingscreenshot from './img/AA2/openingscreenshot.png';
import playscreenshot from './img/AA2/playscreenshot.png';
import winscreen from './img/AA2/winscreen.png';
import losesscreen from './img/AA2/losesscreen.png';
import endlessstart from './img/AA2/endlessstart.png';




export const AuditAttackTwo = ({}) => {



	return (
		<div className="container-fluid appdesc corners">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>Audit Attack Two</h2>
 </div>
 <div className="col-md-4 col-lg-4">
			<a href='https://play.google.com/store/apps/details?id=com.helenssc.auditattacktwo&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' className="appimage img-responsive d-block mx-auto auditpic googlebadge"/></a>
 </div>

 </div>
<div className="row padrow">
<div className="col-md-12 col-lg-12">
			 Still in a contentious audit?  Feel like the auditors just never stop coming?  Take a break from reality and send some virtual auditors back to their conference room!
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={openingscreenshot} alt="Opening screen of Audit Attack Two Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			Tap the auditors as they poke their heads in your door to give you more work.  But watch out!  Don't get your boss or the CFO instead, or your job may be on the line!
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={playscreenshot} alt="Playing screen of Audit Attack Two Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
			 <div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			 Win or lose, it beats an actual audit any day.

 </div>
 </div>
 <div className="row padrow">
			 <div className="col-md-6 col-lg-6 text-center">


	<img src={winscreen} alt="Win Screen" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
	<div className="col-md-6 col-lg-6 text-center">

	 <img src={losesscreen}  alt="Lose Screen" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
			 </div>
				<div className="row padrow">
<div className="col-md-12 col-lg-12">
			Do well enough and you'll get to endless mode, just like in real life!
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={endlessstart} alt="Endless Mode Start Screen" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>





			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 <p>Please note this application was designed primarily for phones.  Ads are displayed.  Feel free to leave us feedback <Link to="/feedback" >
 here
 </Link> .</p>
			 </div>

 </div>
</div>

			)


}
